import { Component, computed, DestroyRef, inject, OnInit, signal } from "@angular/core";
import { AuthenticationError } from "@auth0/auth0-angular";
import { AuthService } from "@kno2/core/auth";
import { OrgSwitcherService } from "@kno2/features/account";
import { FormatAuthErrorPipe } from "./format-auth-error.pipe";

@Component({
    selector: "kno2-auth-error",
    imports: [FormatAuthErrorPipe],
    template: `
        <div style="height: 100vh; background-color: #fff; padding-top: 100px">
            <h1 class="text-center">ERROR: {{ error()?.error | formatAuthError }}</h1>
            <h2 class="text-center">
                <p>{{ error()?.error_description }}</p>
                @if (hasAccessDeniedError()) {
                    <p>You will be redirected to the login screen in {{ seconds() }} seconds.</p>
                }
            </h2>
        </div>
    `
})
export class AuthErrorComponent implements OnInit {
    private readonly authService = inject(AuthService);
    private readonly orgSwitcherService = inject(OrgSwitcherService);
    private readonly destroyRef = inject(DestroyRef);
    protected readonly error = signal<AuthenticationError>(null);
    protected readonly seconds = signal(6);
    protected readonly hasAccessDeniedError = computed(() => this.error()?.error === "access_denied");

    public async ngOnInit(): Promise<void> {
        this.error.set(await this.authService.getError());
        if (await this.orgSwitcherService.resumeAfterSilentDenial(this.error())) return;

        if (this.hasAccessDeniedError()) this.countdown();
    }

    public countdown(): void {
        const interval = setInterval(() => {
            this.seconds.update((seconds) => seconds - 1);
            if (this.seconds() === 0) {
                clearInterval(interval);
                this.authService.logout();
            }
        }, 1000);
        this.destroyRef.onDestroy(() => clearInterval(interval));
    }
}
